import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconNoTrip, IconNoHaggle, IconNoCalls, IconNoWait } from './icons';
import { Reveal } from './Reveal';

/**
 * The friction strip: four things the visitor does NOT have to go through.
 *
 * Each icon draws its own objection, so the row reads at a glance before the copy
 * is read at all. Drawn in Kia red as a point color — this is one of the three
 * places red is allowed, and it is never a fill.
 *
 * Every line describes how the Queens work. None of them promises an outcome,
 * a price, an approval, or a rate.
 */
const ITEMS = [{
  icon: IconNoTrip,
  label: 'pain.1'
}, {
  icon: IconNoHaggle,
  label: 'pain.2'
}, {
  icon: IconNoCalls,
  label: 'pain.3'
}, {
  icon: IconNoWait,
  label: 'pain.4'
}];
export function PainPoints() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="pain-heading" className="w-full bg-white" data-id="element-360" data-mp="3iee3tuz6sds3">
      <h2 id="pain-heading" className="sr-only" data-id="element-361" data-mp="3nbcz4gul6qrv">
        {t('pain.heading')}
      </h2>
      <div className="mx-auto w-full max-w-7xl px-4 pb-4 pt-2 sm:px-6" data-id="element-362" data-mp="1yzn3xk05p8g3">
        <Reveal data-id="element-363" data-mp="1u1txqqyuseft">
          <ul className="grid grid-cols-2 gap-x-4 gap-y-7 border-y border-ink/10 py-8 md:grid-cols-4 md:gap-6" data-id="element-364" data-mp="1u2disgjsviy2">
            {ITEMS.map(item => {
            const Icon = item.icon;
            return <li key={item.label} className="flex flex-col items-center text-center" data-id="element-365" data-mp="23sg9ga3g8kt8">
                  <Icon className="h-9 w-9 text-kred" strokeWidth={1.4} data-id="element-366" data-mp="1g114sao79ret" />
                  <span className="mt-3 max-w-[14ch] font-display text-[13px] font-extrabold uppercase leading-tight tracking-[0.06em] text-ink sm:text-sm" data-id="element-367" data-mp="1b2zizhze3dzn">
                    {t(item.label)}
                  </span>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}